export class FoodPostsaleApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Open a case over an order (the case id is server-minted). */
    open(input) {
        return this.client.request({ method: 'POST', path: '/v1/food-postsale/cases', body: input, auth: true });
    }
    /** Attach evidence (by ref) to a non-resolved case. */
    attachEvidence(caseId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-postsale/cases/${encodeURIComponent(caseId)}/evidence`, body: input, auth: true });
    }
    /** Move an opened case into review. */
    submit(caseId, reviewer) {
        return this.client.request({ method: 'POST', path: `/v1/food-postsale/cases/${encodeURIComponent(caseId)}/submit`, body: { reviewer }, auth: true });
    }
    /**
     * Resolve a case under review/appeal into a balanced money split (returns the split alongside the case). The order is
     * the case's own (D397); pass it only to assert it — a different one is refused `ORDER_MISMATCH`.
     */
    resolve(caseId, order) {
        return this.client.request({ method: 'POST', path: `/v1/food-postsale/cases/${encodeURIComponent(caseId)}/resolve`, body: order !== undefined ? { order } : {}, auth: true });
    }
    /** Reject a case under review/appeal. */
    reject(caseId, by, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/food-postsale/cases/${encodeURIComponent(caseId)}/reject`, body: { by, reasonCode }, auth: true });
    }
    /** Appeal a rejected case (by an actor distinct from the rejecting one). */
    appeal(caseId, by, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/food-postsale/cases/${encodeURIComponent(caseId)}/appeal`, body: { by, reasonCode }, auth: true });
    }
    /** Apply a manual exception (needs `postsale:override`; a still-balanced split), returning the split alongside the case. */
    override(caseId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-postsale/cases/${encodeURIComponent(caseId)}/override`, body: input, auth: true });
    }
    /** Read one case by its id, with its current store revision. */
    get(caseId) {
        return this.client.request({ method: 'GET', path: `/v1/food-postsale/cases/${encodeURIComponent(caseId)}`, auth: true });
    }
    /** An order's post-sale case history, newest first. */
    listByOrder(orderRef) {
        return this.client.request({ method: 'GET', path: `/v1/food-postsale/orders/${encodeURIComponent(orderRef)}/cases`, auth: true });
    }
    /** The open work-queue — every case not yet resolved, newest first. */
    listOpen() {
        return this.client.request({ method: 'GET', path: '/v1/food-postsale/cases', auth: true });
    }
}
//# sourceMappingURL=food-postsale.js.map